import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import styles from './HomeCards.module.css';

const HomeCards: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Row>
      <Col>
        <div className={styles.promoCardList}>
          <div className={styles.promoCardItem}>
            <div className={styles.cardContent}>
              <h6 className={styles.cardContentTitle}>{t('homePage.cards.routinier.title')}</h6>
              <p className={styles.cardContentText}>{t('homePage.cards.routinier.text')}</p>
            </div>
          </div>

          <div className={styles.promoCardItem}>
            <div className={styles.cardContent}>
              <h6 className={styles.cardContentTitle}>{t('homePage.cards.vouchers.title')}</h6>
              <p className={styles.cardContentText}>{t('homePage.cards.vouchers.text')}</p>
            </div>
            <div className={styles.cardFooter}>
              <a className="linkBtn" rel="noopener noreferrer" target="_blank" href={t('homePage.cards.cardLink2')}>
                {t('homePage.cards.schoolCoupon.link')}
                <i className="icon-arrow" />
              </a>
            </div>
          </div>

          <div className={styles.promoCardItem}>
            <div className={styles.cardContent}>
              <h6 className={styles.cardContentTitle}>{t('homePage.cards.schoolCoupon.title')}</h6>
              <p className={styles.cardContentText}>{t('homePage.cards.schoolCoupon.text')}</p>
            </div>
            <div className={styles.cardFooter}>
              <a className="linkBtn" rel="noopener noreferrer" target="_blank" href={t('homePage.cards.cardLink3')}>
                {t('homePage.cards.schoolCoupon.link')}
                <i className="icon-arrow" />
              </a>
            </div>
          </div>
          <div className={styles.promoCardItem}>
            <div className={styles.cardContent}>
              <h6 className={styles.cardContentTitle}>{t('homePage.cards.scooter.title')}</h6>
              <p className={styles.cardContentText}>{t('homePage.cards.scooter.text')}</p>
            </div>
            <div className={styles.cardFooter}>
              <a className="linkBtn" rel="noopener noreferrer" target="_blank" href={t('homePage.cards.cardLink4')}>
                {t('homePage.cards.scooter.link')}
                <i className="icon-arrow" />
              </a>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default HomeCards;
